import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable, of, switchMap, take } from 'rxjs';
import { Injectable } from '@angular/core';

import { Article, BlogService } from './blog.service';

@Injectable({
  providedIn: 'root'
})
export class ArticleResolver {
  constructor(
    private blogService: BlogService,
    private router: Router,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Article> {
    const slug = route.params['slug'];
    return this.blogService.getArticle(slug)
    .pipe(
      switchMap((article: Article) => {
        if (article) {
          return of(article);
        } else {
          this.router.navigate(['/blog']);
          return EMPTY;
        }
      }),
      take(1),
    );
  }
};
